import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';
import './Sidebar.css';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function Sidebar({ onLogout, isOpen: externalIsOpen, onToggle }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [internalOpen, setInternalOpen] = useState(true);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  // Use external state if provided, otherwise use internal state
  const sidebarOpen = externalIsOpen !== undefined ? externalIsOpen : internalOpen;
  const setSidebarOpen = onToggle || setInternalOpen;

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
    fetchMenuItems();
  }, []);

  const fetchMenuItems = async () => {
    try {
      const response = await api.get('/api/sidebar-menu');
      if (response.data.success) {
        setMenuItems(response.data.menuItems);
      }
    } catch (error) {
      console.error('Error fetching menu items:', error);
      // Fallback to default menu items if API fails
      setMenuItems([
        { id: 1, title: 'Dashboard', icon: '📊', path: '/' },
        { id: 2, title: 'Send Messages', icon: '💬', path: '/messages' },
        { id: 3, title: 'Contacts', icon: '📇', path: '/contacts' },
        { id: 4, title: 'Scan QR Code', icon: '📷', path: '/qr' },
        { id: 5, title: 'API Endpoints', icon: '🔗', path: '/api-info' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleMenuClick = (path) => {
    navigate(path);
  };

  return (
    <aside className={`clean-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-top">
        <div className="sidebar-logo-clean">
          <div className="logo-circle">💬</div>
          {sidebarOpen && <h2>WhatsApp</h2>}
        </div>
        <button className="sidebar-close-btn" onClick={() => setSidebarOpen(false)}>
          ✕
        </button>
      </div>

      <div className="user-section">
        <div className="user-avatar-clean">{user?.user_id?.[0]?.toUpperCase() || 'U'}</div>
        {sidebarOpen && (
          <div className="user-details">
            <div className="user-name-clean">{user?.user_id || 'User'}</div>
            <div className="user-email-clean">admin@whatsapp.com</div>
          </div>
        )}
      </div>

      <nav className="nav-menu-clean">
        {loading ? (
          <div className="menu-loading">Loading menu...</div>
        ) : (
          menuItems.map((item) => (
            <a
              key={item.id}
              href="#"
              className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleMenuClick(item.path);
              }}
            >
              <span className="nav-icon">{item.icon}</span>
              {sidebarOpen && <span>{item.title}</span>}
            </a>
          ))
        )}
      </nav>

      {sidebarOpen && (
        <div className="sidebar-bottom">
          <button onClick={onLogout} className="logout-btn-clean">
            🚪 Logout
          </button>
        </div>
      )}
    </aside>
  );
}

export default Sidebar;

